export default __webpack_public_path__ + "static/media/vincennes9.0fe18868.jpg";